import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Copy04 = function Copy04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 16v2.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C14.4802 22 13.9201 22 12.8 22H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 20.4802 2 19.9201 2 18.8v-7.6c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 8 4.08 8 5.2 8H8m3.2 8h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 14.4802 22 13.9201 22 12.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 2 19.9201 2 18.8 2h-7.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C8 3.5198 8 4.08 8 5.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.988.218 2.108.218"
    })
  }));
};
export default Copy04;